import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message } from 'antd';
import { history } from '@umijs/max';
import { isPublicPath } from '@/constants/auth';
import { loginModal } from '@/components/LoginModal';
import { clearCurrentUser } from '@/utils/authState';

/**
 * @name 错误处理
 * 适配后端 HTTP 状态码: 200 正常, 401 登录失效, 500 错误
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理
  errorConfig: {
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.response) {
        // HTTP 错误
        const status = error.response.status;
        const data = error.response.data;

        if (status === 401) {
          // 登录失效 - 清除用户状态并弹出登录弹窗
          localStorage.removeItem('token');
          clearCurrentUser();
          if (!isPublicPath(history.location.pathname)) {
            // message.error('登录已过期，请重新登录');
            loginModal.show();
          }
        } else if (status === 500) {
          // 服务器错误
          const errorMsg = data?.message || data?.error || '服务器错误';
          message.error(errorMsg);
        } else if (status === 403) {
          message.error('没有权限访问');
        } else if (status === 404) {
          message.error('请求的资源不存在');
        } else {
          message.error(`请求错误：${status}`);
        }
      } else if (error.request) {
        message.error('网络异常，请检查网络连接');
      } else {
        message.error('请求异常，请重试');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 从 localStorage 获取 token 并添加到请求头
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = {
          ...config.headers,
          'X-Token': token,
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      return response;
    },
  ],
};
